<template>
    <div class="Gift" ref="outerMain">
        <navigation-bar Back/>
        <div class="main container" ref="main">

            <div class="no-data" v-if="pageData.noticeList.length===0">
                <img src="@/assets/images/empty.svg">
                <p>OH！目前空空的</p>
            </div>

            <!--TODO 消息通知清單-->
            <div class="border-bottom" v-for="(item,index) in pageData.noticeList" :key="index"  @click="checkNotice(item)">
                <notice-item :key="index" :createdAt="item.createdAt" :isRead="item.isRead" :content="item.content" :source="item.source" :contentBody="item.contentBody"/>
            </div>
            <infinite-loading @infinite="setupDataScroll" :identifier="infiniteInfinite" ref="infiniteLoading" spinner="waveDots" v-if="setupListData">
                <div slot="no-more">沒有更多資料</div>
                <span slot="no-results"/>
            </infinite-loading>
        </div>

        <loading
            :active.sync=isLoading
            :can-cancel="false"
            :is-full-page="true"
            v-if="!isComponents">
        </loading>

        <comm-dialog class="dialog-dark" v-if="!isLogin && !isComponents" :value="!isLogin" :outerContent="'請先登入'" :isModal="false" @result="onCommDialogClose"/>
        <notification-dialog class="dialog-dark" v-if="openDialog" :value="openDialog" :outerId="dialogContent.id" :outerContent="dialogContent.content" :outerContentBody="dialogContent.contentBody" :outerContent2="dialogContent.content2" :isModal="false" :isCancel="true" @result="onCheckNoticeDialogClose"/>
    </div>
</template>

<script>
    import CommDialog from '@/components/CommDialog.vue';
    import NoticeItem from './components/NoticeItem.vue';
    import NotificationDialog from './components/NotificationDialog.vue';
    import {notNull} from "@/util/common";
    import * as mutationTypes from '@/store/mutationTypes'


    export default {
        name: "Notification",
        components: {
            CommDialog,
            NoticeItem,
            NotificationDialog,
        },
        props: {
            isComponents: {default: false}, //當組件引入使用
        },
        data() {
            return {
                isLoading: false,
                isLogin: this.$auth.isAdminLogin(),

                openDialog:false,
                dialogContent:{
                    content:"",
                    content2:"",
                },
                //下拉載入用
                pageSize: 10,
                setupListData: false,
                infiniteInfinite: 0,
                infiniteLoadingListState: '',
                pageData: {
                    scrollTo: '',           //列表捲動的位置
                    offsetHeight: 0,        //列表的高度
                    noticeList: [],
                    currentPage: 0,         //初始頁數
                },
            }
        },
        created() {

        },
        mounted() {
            //讀取資料，沒有資料的話就重抓
            if ( this.hasSnapshot() ) {
                this.restoreFromSnapshot();

                //讀完以後刪除
                this.saveToSnapshot('delete');
                this.setupListData = true;

            } else {
                if (this.isLogin) {
                    if (this.pageData.noticeList.length === 0) {
                        this.startLoading();
                    }
                }
            }
        },
        beforeRouteLeave: function(to, from, next) {
            // 記住快照
            // 如果不是返回上一頁的話就記住快照
            if ( from.name === 'Notify' && ['Home'].indexOf(to.name) === -1) {
                this.updateScrollValue();
                this.saveToSnapshot(this.pageData);
            }
            next();

        },
        updated: function (params) {
            // 渲染完成後等一下才捲到目標位置
            setTimeout(() => {
                //回復店家列表捲動狀態
                this.restoreScroll();
            }, 100);
        },
        methods: {

            setupData: function () {
                // this.isLoading = true;
                // //消息通知
                // this.$http.fetchWithAuth`GetNoticeList${{
                // }} ${json => {
                //     if (notNull(json.data)) {
                //         this.noticeList = json.data;
                //     }
                //     this.isLoading = false;
                // }}`;
            },

            /** 更新店家列表捲動狀態數值 */
            updateScrollValue: function() {
                let pData = this.pageData;
                //手機版紀錄捲動位置
                let object = this.$refs.main

                //網頁版紀錄捲動位置
                const fullWidth = window.innerWidth;
                if(fullWidth>=1024){
                    object = this.$refs.outerMain
                }

                if (this.$public.notNull(object)) {
                    pData.scrollTo = object.scrollTop;
                    pData.offsetHeight = object.offsetHeight;
                }
            },

            /** 回復店家列表捲動狀態 */
            restoreScroll: function() {
                let pData = this.pageData;
                if (this.$public.notNull(pData.scrollTo) && pData.scrollTo !== '') {
                    //手機版紀錄捲動位置
                    let object = this.$refs.main

                    //網頁版紀錄捲動位置
                    const fullWidth = window.innerWidth;
                    if(fullWidth>=1024){
                        object = this.$refs.outerMain
                    }

                    if (this.$public.notNull(object)) {
                        if (pData.offsetHeight === object.offsetHeight) {
                            object.scrollTo(0, pData.scrollTo);
                        }
                    }
                    pData.scrollTo = '';
                }
            },

            /** 將pageData存到暫存中 */
            saveToSnapshot(data) {
                this.$store.commit("saveNotifyPageSnapshot", data);
            },

            /** 是否有暫存 */
            hasSnapshot: function() {
                return this.$public.notNull(this.$store.state?.notifyPageSnapshot?.offsetHeight);
            },

            /** 將暫存的資料回存 */
            restoreFromSnapshot() {
                if ( this.$public.notNull(this.$store.state?.notifyPageSnapshot?.offsetHeight)) {
                    this.pageData = this.$store.state?.notifyPageSnapshot;
                }
            },

            /** 取得推播資料列表 */
            getNoticeListWithState: function ($state) {
                let self = this;
                return new Promise(function(resolve, reject) {
                    self.isLoading = true;
                    self.$http.fetchWithAuth`GetNoticeList${{
                        offset: self.pageData.currentPage,
                    }} ${json => {
                        self.isLoading = false;
                        if (self.$public.notNull(json.data)) {

                            self.pageData.currentPage++;

                            //轉換，新增一個 source 變數顯示通知的來源
                            json.data.forEach(item => {
                                let noticeData = item;

                                //如果原本沒有 source這個欄位
                                if (!self.$public.notNull(item.source)) {
                                    noticeData.source = '';

                                    //組合推播來源，放進 source欄位
                                    if (self.$public.notNull(item.fcmData) && item.fcmData !== "") {
                                        let fcmData = JSON.parse(item.fcmData);

                                        if (self.$public.notNull(fcmData.brandName)) {
                                            noticeData.source = fcmData.brandName;
                                        }
                                        if (self.$public.notNull(fcmData.storeName)) {
                                            if (noticeData.source !== '') {
                                                noticeData.source = noticeData.source + `-${fcmData.storeName}`;
                                            } else {
                                                noticeData.source = fcmData.storeName;
                                            }
                                        }
                                    }
                                }

                                self.pageData.noticeList.tmz_load_push(noticeData);
                            });

                            //只顯示10筆
                            // self.noticeList.tmz_load_push(...json.data);

                            if (json.data.length >= self.pageSize) {
                                //如果取得的資料筆數 >= 預設的每頁最大資料筆數
                                $state.loaded();
                            } else {
                                $state.complete();
                            }

                            //完成
                            resolve();
                        } else {
                            //失敗
                            reject('失敗');
                        }
                    }}`;
                });
            },

            startLoading() {
                let self = this;
                self.isLoading = false;
                setTimeout(function(){
                    if (!self.setupListData) {
                        self.setupListData = true;
                        if (self.infiniteLoadingListState !==  '') {
                            self.infiniteLoadingListState.reset();
                        }
                    }

                    //改變 infiniteInfinite，並且畫面已經捲到底，才能讓 infinite-loading觸發載入事件
                    self.infiniteInfinite += 1;
                },100)
            },

            /** 載入更多 */
            setupDataScroll: function ($state) {
                let self = this;
                self.infiniteLoadingListState = $state

                self.getNoticeListWithState($state)
                    .catch( (error) => {
                        //this.isLoading = false;
                        self.$store.commit(mutationTypes.SHOW_TOAST, error);
                    });

            },

            /** CommDialog 關閉事件 */
            onCommDialogClose: function (result) {
                if (result) {
                    this.$router.push({name: 'Login'});
                } else {
                    this.$router.go(-1)
                }
            },

            /** 開啟通知Dialog */
            checkNotice: function (item) {
                // this.dialogContent.content = item.content;
                // this.dialogContent.contentBody = item.contentBody;
                // this.dialogContent.content2 = item.createdAt;
                // this.dialogContent.id = item.id;
                // this.openDialog = true;

                //跳到對應的頁面
                this.$public.clickNotificationRouter( item.fcmData, this.$route.name);

            },

            /** 通知Dialog刪除或確定事件 */
            onCheckNoticeDialogClose: function (result,result2) {
                this.openDialog = false;
                if (result === 'read') {
                    this.isLoading = true;

                    //更新消息通知為已讀
                    this.$http.fetchWithAuth`UpdateNoticeIsRead${{
                        noticeIdArray:[result2],
                    }} ${json => {
                        if (json.status) {
                            this.pageData.noticeList.map( (item) => {
                                if (item.id === result2) {
                                    item.isRead = true;
                                }
                                return item;
                            });
                        }
                        this.isLoading = false;
                    }}`;

                }else if (result === 'delete') {
                    this.isLoading = true;
                    //刪除消息通知
                    this.$http.fetchWithAuth`DeleteNotice${{
                        noticeIdArray:[result2],
                    }}  ${json => {
                        if (json.status) {
                            this.pageData.noticeList = this.pageData.noticeList.filter( (item) => {
                                return item.id !== result2;
                            });
                        }
                        this.isLoading = false;
                    }}`;
                }
            }
        }
    }
</script>

<style lang="less" scoped src="../../less/gift.less"/>